import { render, staticRenderFns } from "./TabPreview.vue?vue&type=template&id=199ce843&scoped=true"
import script from "./TabPreview.vue?vue&type=script&lang=js"
export * from "./TabPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ce843",
  null
  
)

export default component.exports